module.exports = __webpack_public_path__ + "img/budapestwhere.5d4aeca.jpeg";